import {CHESTS} from '../constants/chests';

// Ежедневные награды за вход: 4 недели по 7 дней, индекс = (стрик - 1) % 28.
// После 28-го дня цикл начинается заново (стрик продолжает расти, награды
// идут по кругу). Пропуск дня (игровые сутки, см. getGameDayKey) сбрасывает
// стрик на 1. Общий конфиг клиента (модалка в главном меню) и сервера
// (/api/daily-login-reward/claim) — награды обязаны совпадать.
export const DAILY_LOGIN_REWARDS = [
  // Неделя 1
  {numens: 50},
  {numens: 100},
  {numens: 150},
  {numens: 200},
  {numens: 250},
  {numens: 300},
  {chestId: CHESTS.SKINS_IRON},
  // Неделя 2
  {numens: 150},
  {numens: 200},
  {numens: 250},
  {numens: 300},
  {numens: 400},
  {numens: 500},
  {chestId: CHESTS.UNIT_SKINS_IRON},
  // Неделя 3
  {numens: 200},
  {numens: 300},
  {numens: 400},
  {chestId: CHESTS.SKINS_IRON},
  {chestId: CHESTS.UNIT_SKINS_IRON},
  {chestId: CHESTS.SKINS_SILVER},
  {chestId: CHESTS.UNIT_SKINS_SILVER},
  // Неделя 4
  {crystals: 5},
  {crystals: 10},
  {crystals: 15},
  {crystals: 20},
  {crystals: 25},
  {chestId: CHESTS.RANDOM_DEFAULT},
  {chestId: CHESTS.RANDOM_EPIC},
];

export const DAILY_LOGIN_REWARDS_PREMIUM = [
  // Неделя 1
  {numens: 200},
  {numens: 250},
  {numens: 300},
  {numens: 450},
  {numens: 500},
  {chestId: CHESTS.SKINS_IRON},
  {chestId: CHESTS.UNIT_SKINS_IRON},
  // Неделя 2
  {numens: 400},
  {numens: 500},
  {numens: 600},
  {numens: 700},
  {numens: 800},
  {chestId: CHESTS.SKINS_SILVER},
  {chestId: CHESTS.UNIT_SKINS_SILVER},
  // Неделя 3
  {numens: 600},
  {numens: 800},
  {numens: 1000},
  {chestId: CHESTS.SKINS_SILVER},
  {chestId: CHESTS.UNIT_SKINS_SILVER},
  {chestId: CHESTS.SKINS_GOLD},
  {chestId: CHESTS.UNIT_SKINS_GOLD},
  // Неделя 4
  {crystals: 20},
  {crystals: 30},
  {crystals: 40},
  {crystals: 50},
  {chestId: CHESTS.RANDOM_DEFAULT},
  {chestId: CHESTS.RANDOM_EPIC},
  {chestId: CHESTS.RANDOM_LEGENDARY},
];

export const DAILY_LOGIN_REWARDS_CYCLE_DAYS = DAILY_LOGIN_REWARDS.length;

// Индекс награды (0-based) для стрика (1-based, продолжает расти бесконечно)
export const getDailyLoginRewardIndex = (streak) =>
  ((Math.max(1, streak) - 1) % DAILY_LOGIN_REWARDS_CYCLE_DAYS);
